<template>
	<div>
		<div id="main-wrapper">
			<!-- Show Header for authenticated users on laptop/desktop -->
			<!-- <Header
				v-if="(hasAccess() && isLaptop) || (hasAccess() && isPublicProfile)"
			/> -->
			<Header
				v-if="(hasAccess() && isLaptop) || (hasAccess() && isPublicProfile)"
			/>
			<!-- Show GuestHeader for non-authenticated users or on mobile -->
			<GuestHeader v-else-if="!hasAccess() && !assessmentMobile" />

			<AppMain />
			<MobBottomNav v-if="!hasAccess()" />
		</div>
	</div>
</template>

<script>
import GuestHeader from "@/components/fixedcomponents/GuestHeader.vue";
import Header from "@/components/LandingPage/LandingpageHeader.vue";
import AppMain from "@/components/Layout/AppMain";
import { mapGetters } from "vuex";
import { getToken, hasAccess } from "@/utils/tokenCheck.js";
import MobBottomNav from "@/components/fixedcomponents/MobBottomNav.vue";
export default {
	name: "Layout",

	components: {
		Header,
		GuestHeader,
		AppMain,
		MobBottomNav,
	},
	data() {
		return {
			isLaptop: true,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			vuexToken: "getToken",
		}),

		isAuthenticated() {
			// Check if user has a valid token reactively
			return !!(this.vuexToken || getToken());
		},
		isPublicProfile() {
			return this.$route.name === "ViewPublicProfile";
		},
		assessmentMobile() {
			return (
				this.$route.name === "CandidateAssessmentProgress" && !this.isLaptop
			);
		},
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	methods: {
		hasAccess() {
			return hasAccess();
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
	},
};
</script>

<style>
@media (min-width: 1029px) {
	#main-wrapper {
		height: 100vh;
		overflow: hidden;
	}
}
</style>
